module.exports = __webpack_public_path__ + "static/media/4_r_sculpturi_82.19_61.94.58bb9086.png";